<script setup lang="ts">
import { KsIcon } from '@aschehoug/kloss'
import { useAuthStore } from '~/stores/auth'
import { storeToRefs } from 'pinia'
import useBanner from '~/composables/banner'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const authStore = useAuthStore()
const { banner } = useBanner()
const { isAuthenticated } = storeToRefs(authStore)
const route = useRoute()

const textColor = computed(() => isAuthenticated.value && banner.value && route.name !== 'search' ? 'text-white' : 'text-seagreen-50')
</script>

<template>
  <KsIcon
    id="logo-aunivers"
    :class="textColor"
  />
</template>
